import Swiper from 'swiper/bundle';

const storySlider = document.querySelector(".story-slider");

const mySwiper = new Swiper(storySlider, {
  effect: 'fade',
  loop: true,
  // autoplay: {
  //   delay: 5000,
  // },  
  fadeEffect: {
    crossFade: true,
  },
  speed: 700,
  navigation: {
    nextEl: '.story-slider-wrapper .story-button-next',
    prevEl: '.story-slider-wrapper .story-button-prev',
  }
});